import React, { useState } from 'react';
import { TextInput as RNTextInput, StyleSheet } from 'react-native';
import { ADMIN_COLORS, ADMIN_FONT } from '../../config/theme/adminColors';

// Modern, neutral text input for the admin panel.
// Flat surface, rounded border, accent focus ring, system font — never the client's brand.
// Drop-in for react-hook-form: pass value + onChangeText (and onBlur).
const AdminInput = ({ style, multiline, value, onFocus, onBlur, ...props }) => {
  const [focused, setFocused] = useState(false);

  return (
    <RNTextInput
      placeholderTextColor={ADMIN_COLORS.placeholder}
      {...props}
      value={value == null ? '' : String(value)}
      multiline={multiline}
      onFocus={(e) => {
        setFocused(true);
        onFocus && onFocus(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        onBlur && onBlur(e);
      }}
      style={[
        styles.input,
        multiline && styles.multiline,
        focused && styles.focused,
        style,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  input: {
    height: 44,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.border,
    borderRadius: 10,
    paddingHorizontal: 14,
    marginTop: 6,
    backgroundColor: ADMIN_COLORS.surface,
    color: ADMIN_COLORS.ink,
    fontFamily: ADMIN_FONT,
    fontSize: 15,
    // web: remove the default browser focus outline (we render our own ring)
    outlineStyle: 'none',
  },
  multiline: {
    height: undefined,
    minHeight: 92,
    paddingTop: 12,
    textAlignVertical: 'top',
  },
  focused: {
    borderColor: ADMIN_COLORS.teal,
    boxShadow: '0 0 0 3px rgba(43, 147, 237, 0.16)',
  },
});

export default AdminInput;
